<template>
  <path d="M0 100 C40 0 60 0 100 100 Z"></path>
</template>
